// Copyright 1999-2022. Plesk International GmbH. All rights reserved.

import { NOTIFICATION_CATEGORIES } from './PropTypes';

export default notification => [NOTIFICATION_CATEGORIES.ALERT, NOTIFICATION_CATEGORIES.WARNING].indexOf(notification.category) >= 0;
